import { DivineControlEvent } from "../../../DivineControlEventBase.js";
export class DCBaseGamepadAxesEvent extends DivineControlEvent {
    eventType = "gamepad-axes-move";
    inputType = "gamepad-axes";
    axes = [0, 0];
    constructor() {
        super();
    }
    getStick() {
        return this.getData().stick;
    }
}
